<script lang="ts" setup>
  import type { RestaurantHour } from '@/types/api/restaurant'

  defineProps<{
    hours: RestaurantHour[]
  }>()
</script>

<template>
  <CDropdown>
    <template #trigger>
      <span
        :class="['dropdown-trigger-text', { 'trigger-text-public-holiday': hours[0].description === 'Public Holiday' }]"
      >
        <span class="day-name">
          {{ hours[0].name }}
        </span>
        <span class="day-description">
          {{ hours[0].description }}
        </span>
      </span>
    </template>
    <template #list>
      <div
        v-for="(day, i) in hours"
        :key="i"
        :class="['dropdown-menu-item', { 'public-holiday': day.description === 'Public Holiday' }]"
        role="menuitem"
      >
        <span class="day-name">
          {{ day.name }}
        </span>
        <span class="day-description">
          {{ day.description }}
        </span>
      </div>
    </template>
  </CDropdown>
</template>

<style lang="scss" scoped>
  :deep(.dropdown-trigger) {
    padding: 8px 0;
  }

  .dropdown-trigger-text {
    @include typography-body;
    cursor: pointer;
    display: flex;
    gap: 32px;
  }

  .trigger-text-public-holiday {
    color: var(--color-text-muted);
  }

  .dropdown-menu-item {
    display: flex;
    justify-content: space-between;
    gap: 16px;

    padding: 12px 16px;

    @include typography-body-small;

    color: var(--color-base-white);
  }

  .public-holiday {
    color: var(--color-secondary-green-light);
  }
</style>
